import { ClipBoardTooltip } from "@/components/ClipBoardTooltip.tsx";
import { DetailsTableRow } from "@/components/table/DetailsTableRow.tsx";
import { IpAddressSelect, type IpAddressSelectSelectLoaderProps } from "@/modules/network/IpAddressSelect.tsx";
import { useLingui } from "@lingui/react/macro";

export interface DetailsTableIpAddressProps extends Pick<
    IpAddressSelectSelectLoaderProps,
    "value" | "location" | "isLoading" | "onChange"
> {}

export function DetailsTableIpAddress({ ...props }: DetailsTableIpAddressProps) {
    const { t } = useLingui();
    const { value } = props;
    return (
        <DetailsTableRow title={t`Public IPv4`} tooltip={t`Public IP addresses are managed in the Network view.`}>
            <div className="flex items-center">
                <IpAddressSelect enableInlineEditing {...props} />
                {!!value && <ClipBoardTooltip text={value.address} />}
            </div>
        </DetailsTableRow>
    );
}
